import parse from "html-react-parser";
import React from "react";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";

interface IProps {
  title: string;
  description?: string;
  alertDescription?: string;
  isOpen?: boolean;
  showIcon?: boolean;
  children?: React.ReactNode;
  handleOpen?: () => void;
}

function Accordion({
  title,
  description,
  alertDescription,
  isOpen = false,
  showIcon = true,
  children,
  handleOpen,
}: IProps) {
  return (
    <div
      onClick={() => {
        handleOpen?.();
      }}
      role="presentation"
    >
      <div className="flex cursor-pointer items-center gap-0.5">
        {showIcon ? <Icon name={isOpen ? IconName.Default_700 : IconName.Plus_100_small} /> : null}
        <span className="h-4.5 uppercase">{title}</span>
      </div>
      {isOpen
        ? (children ?? (
            <p className="font-regular pt-2.5 whitespace-pre-wrap">
              {parse(description || "")}
              <br />
              <span className="text-highlight mt-2.5 block w-full">{alertDescription}</span>
            </p>
          ))
        : null}
    </div>
  );
}

export default Accordion;
